import PropTypes from 'prop-types';
import React from 'react';
import bindAll from 'lodash.bindall';
import styles from './barChart2.module.css';
import * as echarts from 'echarts';
import {getHzDzRankingXueqiRequest} from "../../../service/report";
import PubSub from "pubsub-js";
var myLineChart = null;

class BarChart2 extends React.Component {
    constructor(props) {
        super(props);
        bindAll(this, [
            'initLineBar',
            'getHzDzRanking'
        ]);

        this.state = {
            paiming:'',
            dzMineNum:'',
            dzAverageNum:'',
            dzMaxNum:''
        };

        PubSub.unsubscribe('barChart111Update');
        PubSub.subscribe('barChart111Update', (event, data) => {
            //console.log(data);
            this.getHzDzRanking(data);
        });

    }

    componentDidMount() {

    }

    getHzDzRanking(data){
        if(data.ret=='1'){
            this.setState({
                // dzMineNum:data.data.student_hz_dz.value,
                dzMineNum:data.data.student_hz_dz.dianzan,
                dzAverageNum:data.data.class_avg.davg,
                dzMaxNum:data.data.class_avg.dmax,
                paiming:data.data.student_hz_dz.dpm
            });

            var davg = parseFloat(data.data.class_avg.davg).toFixed(2);

            // var xzdata =  [data.data.class_avg.dmax,davg,data.data.student_hz_dz.value];
            var xzdata =  [data.data.class_avg.dmax,davg,data.data.student_hz_dz.dianzan];
            this.initLineBar(xzdata);

        }

    }

    componentDidUpdate() { // 组件更新后触发


    }

    componentWillUnmount (){
        myLineChart.dispose();
    }

    initLineBar(data) {
        const colors = ['#dfd827','#59c675','#e5a539'];

        var xzdata =  data;
        var yzdata = ['班级最高', '班级平均','我的评价'];

        var option = {
            tooltip: {
                show:false,
                trigger: 'axis',
                axisPointer: {
                    type: 'shadow'
                }
            },
            grid: {
                top:'0%',
                left: '5%',
                bottom: '2%',
                containLabel: true
            },
            xAxis: {
                type: 'value',
                boundaryGap: [0, 0.01],
                position: 'top',
                axisLine:{
                    lineStyle:{
                        color:"#fff",
                        width:1,
                    }
                },
                splitLine: {     //网格线
                    "show": false
                },
                axisLabel:{
                    show:false
                }
            },
            yAxis: {
                type: 'category',
                data: yzdata,
                axisLine:{
                    show:false,
                    lineStyle:{
                        color:'#3291d3',
                        width:1,
                    }
                },
                axisTick:{
                    show: false //不显示坐标轴刻度线
                },

                axisLabel: {
                    margin: 10,
                    textStyle: {
                        color: '#3291d3',
                        fontSize: 16,//字体大小
                    },
                },
            },
            series: [
                {
                    type: 'bar',
                    data: xzdata,
                    label: {   //设置柱状图上显示  对应值
                        show: true,
                        position: 'right',
                        color:'#3291d3',
                        textStyle: {
                            fontSize: 16,//字体大小
                        },
                    },
                    barWidth : 20,

                    itemStyle: {
                        normal: {
                            color: function(params) {   // 设置前三个颜色不一样
                                var num = params.value;
                                var djg = params.dataIndex;   //第几个数

                                return colors[params.dataIndex]
                            },
                            barBorderRadius: [15, 15, 15, 15] // 设置柱状图圆角（顺时针左上，右上，右下，左下）
                        },

                    },
                },

            ]
        };


        myLineChart = echarts.init(document.getElementById('barChart222'));
        myLineChart.setOption(option, true)

    }


    render() {

        return (
            <div className={styles.root}>
                <div className={styles["div-title"]}>
                    <div className={styles["text-green"]}>评价班级排名</div>
                    <div className={styles["text-red"]}>{this.state.paiming}</div>
                </div>
                <div id="barChart222" className={styles.echart} ></div>

            </div>
        )
    }
}


export default BarChart2;
